import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import api from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { Wrench } from "@phosphor-icons/react";

// Fail-open gate: only blocks public visitors when mode is MAINTENANCE.
export const LaunchGate = ({ children }) => {
  const { user } = useAuth();
  const location = useLocation();
  const [mode, setMode] = useState(null);

  useEffect(() => {
    api.get("/public/launch-mode").then((r) => setMode(r.data.mode)).catch(() => setMode("PUBLIC_LAUNCH"));
  }, []);

  const path = location.pathname;
  const allowed = ["/login", "/register", "/forgot-password", "/reset-password", "/admin"].some((p) => path.startsWith(p));

  if (mode === "MAINTENANCE" && user?.role !== "admin" && !allowed) {
    return (
      <div className="flex min-h-screen flex-col items-center justify-center bg-stone-50 px-6 text-center" data-testid="maintenance-screen">
        <Wrench size={56} weight="duotone" className="text-primary" />
        <h1 className="mt-4 font-heading text-2xl font-bold text-stone-900">We'll be right back</h1>
        <p className="mt-2 max-w-sm text-sm text-stone-500">Avinya Bookings is undergoing brief maintenance. Please check back shortly — your existing bookings are safe.</p>
        <p className="mt-6 text-[11px] font-semibold uppercase tracking-[0.3em] text-amber-600">Book · Relax · Celebrate</p>
      </div>
    );
  }
  return children;
};
